import { h } from '../dom';

const TOAST_DURATION_MS = 4500;

/** Affiche une notification temporaire en bas de l'écran. */
export function createToaster(
  container: HTMLElement,
): (message: string, kind?: 'info' | 'error') => void {
  return (message, kind = 'info') => {
    const toast = h(
      'div',
      { class: `toast toast-${kind}`, role: kind === 'error' ? 'alert' : 'status' },
      message,
    );
    container.appendChild(toast);
    window.setTimeout(() => toast.remove(), TOAST_DURATION_MS);
  };
}
